import { useLoginContext } from '../../../App';

// The `criteria` input is expected to be an array of objects, where each object can have:
// - productsRequired: array of product acronyms (strings) the user must have
// - rolesRequired: array of role names (strings) the user must have
// Example:
// [
//   {
//     productsRequired: ['PROD1', 'PROD2'],
//     rolesRequired: ['ADMIN', 'USER']
//   },
//   {
//     rolesRequired: ['SUPERUSER']
//   }
// ]
const useAccessControl = (criteria = null) => {
    const { loginData } = useLoginContext();
    
    const createCriteria = (productsRequired = null, rolesRequired = null) => {
        const criterion = {};
        if (productsRequired) {
            criterion.productsRequired = Array.isArray(productsRequired) ? productsRequired : [productsRequired];
        }
        if (rolesRequired) {
            criterion.rolesRequired = Array.isArray(rolesRequired) ? rolesRequired : [rolesRequired];
        }
        return [criterion];
    };
    
    const checkAccess = () => {
        // console.log('loginData:', loginData);
        // console.log('criteria:', criteria);
        if (!loginData || !criteria) {
            return false;
        }
        const evaluation = criteria.some(criterion => {
            const hasRequiredProducts = !criterion.productsRequired || criterion.productsRequired.every(product => loginData.productAcronyms.includes(product));
            const hasRequiredRole = !criterion.rolesRequired || criterion.rolesRequired.some(role => loginData.roles.includes(role) || loginData.roles.includes(`ROLE_${role}`));
            return hasRequiredProducts && hasRequiredRole;
        });
        // console.log('evaluation:', evaluation);
        return evaluation;
    };
    return { checkAccess, createCriteria };
};

export default useAccessControl;